import { render, staticRenderFns } from "./ASecondaryBtn.vue?vue&type=template&id=5a28ad1c&"
import script from "./ASecondaryBtn.vue?vue&type=script&lang=ts&"
export * from "./ASecondaryBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports